import { useState, useCallback } from 'react';
import { TimelineEvent } from '../types/consumerRequest';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { 
  ActivityLogFilters,
  ActivityLogListResponse,
  ActivityLog
} from '../types/activityLogs';
import { activityLogTabApi } from '../apis/activityLogTab';


// Hook for activity logs by entity
export function useActivityLogs(
  params: {
    entityId: string;
    remoteUtilityId: number;
    actionType: string
  }
) {
  const { data: activityLogs, isLoading } = useQuery({
    queryKey: ['activityLogsByEntity', params],
    queryFn: () => activityLogTabApi.getActivityLogs(params),
    enabled: !!params.entityId && !!params.remoteUtilityId,
  });

  return {
    activityLogs,
    isLoading,
  };
}
